/**
 * Format a date string to a localized format
 * @param {string|Date} date - The date to format
 * @param {string} format - 'short', 'long', or 'year'
 * @returns {string} Formatted date string
 */
export const formatDate = (date, format = 'long') => {
  const formatOptions = {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: { year: 'numeric', month: 'long', day: 'numeric' },
    year: { year: 'numeric' },
  };

  return new Date(date).toLocaleDateString(
    'en-US',
    formatOptions[format] || formatOptions.long
  );
};

/**
 * Format read time display
 * @param {string} readTime - Read time string (e.g., "5 min read")
 * @returns {string} Formatted read time
 */
export const formatReadTime = (readTime) => {
  return readTime || 'Quick read';
};

/**
 * Remove frontmatter from markdown content
 * @param {string} markdown - Markdown content with potential frontmatter
 * @returns {string} Markdown without frontmatter
 */
export const stripFrontmatter = (markdown) => {
  return markdown.replace(/^---[\s\S]*?---\n/, '');
};

/**
 * Get current year for copyright
 * @returns {number} Current year
 */
export const getCurrentYear = () => {
  return new Date().getFullYear();
};